import {Component, EventEmitter, Output} from '@angular/core';
import {Observable} from 'rxjs';
import {NgRedux} from '@angular-redux3/store';
import {PlaylistRemoteAppState} from '../../store';

@Component({
  selector: 'mwo-scheduler-modifier-header',
  templateUrl: './scheduler-modifier-header.component.html',
  styleUrls: ['./scheduler-modifier-header.component.scss']
})
export class SchedulerModifierHeaderComponent {

  activeDay$: Observable<string> = this.ngRedux.select('activeDay');
  @Output() onBreadcrumbClicked: EventEmitter<any> = new EventEmitter<any>();

  constructor(private ngRedux: NgRedux<PlaylistRemoteAppState>) {
  }

  handleBreadcrumbClick() {
    this.onBreadcrumbClicked.emit();
  }

}
